/**
 * Каналы, которые платформа умеет вести.
 *
 * Отдельным файлом, а не внутри channel.ts, ради графа сценария: он
 * доступен админке отдельным входом пакета именно потому, что через
 * общий index в её программу попали бы порты с типами Node
 * (`import type { Readable } from 'node:stream'`). Список каналов нужен
 * и графу, и портам — и не должен тащить за собой ничего.
 *
 * Список закрытый: провайдер определяет и способ запуска воркера, и
 * разбор адресов, и набор возможностей — то есть код, который надо
 * написать, а не настройку, которую можно дописать в конфигурации.
 */
export const CHANNEL_PROVIDERS = ['whatsapp', 'telegram'] as const

export type ChannelProvider = (typeof CHANNEL_PROVIDERS)[number]
